module.exports = __webpack_public_path__ + "static/media/info-circle-solid.df6da8a7.svg";